export default __webpack_public_path__ + "static/media/coriolis-logo-dark.421751fb.png";